import Input from './Input';
import Group from './Group';
import Search from './Search';
import TextArea from './TextArea';
import Password from './Password';
Input.Group = Group;
Input.Search = Search;
Input.TextArea = TextArea;
Input.Password = Password;
export default Input;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/input/index.js
// module id = 169
// module chunks = 14